import {Map, fromJS, List} from "immutable";

import {FETCH_EXECUTIONS_REQUEST, FETCH_EXECUTIONS_SUCCESS, FETCH_EXECUTIONS_ERROR, CREATE_EXECUTIONS_REQUEST, CREATE_EXECUTIONS_SUCCESS, CREATE_EXECUTIONS_ERROR } from "./executions-actions"

const executions = (state = Map({
    payload: List([]),
    isFetching: false,
    error: false
}), action) => {
    let newState;
    switch (action.type) {

        // Requests
        case FETCH_EXECUTIONS_REQUEST:
            newState = state.merge({
                isFetching: true,
                error: false
            });
            return newState;

        // Success
        case FETCH_EXECUTIONS_SUCCESS:
            newState = state.merge({
                payload: fromJS(action.payload),
                isFetching: false,
                error: false
            });
            return newState;

        // Errors
        case FETCH_EXECUTIONS_ERROR:
            newState = state.merge({
                isFetching: false,
                error: action.error,
                errorMessage: action.errorMessage
            });
            return newState;

        // Requests
        case CREATE_EXECUTIONS_REQUEST:
            newState = state.merge({
                isFetching: true,
                error: false
            });
            return newState;

        // Success
        case CREATE_EXECUTIONS_SUCCESS:
            newState = state.merge({
                payload: state.payload.push(fromJS(action.payload)),
                isFetching: false,
                error: false
            });
            return newState;

        // Errors
        case CREATE_EXECUTIONS_ERROR:
            newState = state.merge({
                isFetching: false,
                error: action.error,
                errorMessage: action.errorMessage
            });
            return newState;

        default:
            return state;
    }
};

export default executions;